module.exports = __webpack_public_path__ + "img/seo-phone-icon.svg";